export var compareVersions = function (v1, v2) {
    var _a, _b;
    var parts1 = v1.split('.').map(Number);
    var parts2 = v2.split('.').map(Number);
    var maxLength = Math.max(parts1.length, parts2.length);
    for (var i = 0; i < maxLength; i++) {
        var num1 = (_a = parts1[i]) !== null && _a !== void 0 ? _a : 0;
        var num2 = (_b = parts2[i]) !== null && _b !== void 0 ? _b : 0;
        if (num1 > num2)
            return 1;
        if (num1 < num2)
            return -1;
    }
    return 0;
};
